import {
    Component,
    ViewChild,
    OnInit,
    ElementRef,
    Renderer2,
    Input,
    Output,
    EventEmitter,
    OnDestroy
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Vehicle } from '../../interfaces/vehicle';
import { Documentos } from '../../interfaces/documents';
import { Courtesies } from '../../interfaces/courtesies';
import { AuthService } from '../../services/auth.service';
import { CanBeDeleteService } from '../../../dms/modulos/general/componentes/gestion-terceros/servicios/can-be-delete.service';
import { GestionTercerosService } from '../../../dms/modulos/general/componentes/gestion-terceros/gestion-terceros.service';
import { SharedPanelService } from '../../../dms/layout/shared-panel/shared-panel.service';
import { AutoUnsubscribe } from '../../decorators/auto-unsubscribe';
import { ClientCustomerRegistryModel } from '../../models/clientCustomerRegistry';
import { GlobalsService } from '../../services/globals.service';
import { Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { SupplierCustomerRegistryModel } from '../../models/supplierCustomerRegistry';
import { GeneralGestionTercerosService } from '../../../dms/modulos/general/componentes/gestion-terceros/servicios/general-gestion-tercerosService.Service';
import { DataSaveService } from '../../services/data-save.service';
import { Categories } from '../../interfaces/categories';
import { RecepcionVehiculoStepsService } from '../../../dms/modulos/taller/componentes/recepcion-vehiculo/recepcion-vehiculo-steps.service';
import { AdjuntarDocumentosService } from '../../../shared/components/adjuntar-documentos/adjuntar-documentos.service';
import { ChildsMenuEnum } from '../../enums/childs-menu.enum';
import { LoadingService } from '../../../shared/loading/loading.service';
import {CustomerValidationService} from '../../services/customer-validation.service';
import { EmailMessageData } from '../../../dms/layout/modals/modal-mail/modal-mail-data';
import { ORCustomerVehicleService } from '../../services/or-customer-vehicle.service';
import {ButtonsActivateService} from '../../services/buttons-activate.service';
import * as moment from 'moment';

@Component({
    selector: 'app-gestion-terceros-register',
    templateUrl: './gestion-terceros-register.component.html',
    styleUrls: ['./gestion-terceros-register.component.scss']
})
@AutoUnsubscribe()
export class GestionTercerosRegisterComponent implements OnInit, OnDestroy {

    @ViewChild('tabstripCarrousel', { static: false }) tabstripCarrousel: ElementRef;
    @Input() cargarVista?: string;
    @Input() tab?: number;
    @Input() isGDPRAuthorized?: boolean;
    @Input() isModal: boolean = false;
    @Output() cancel = new EventEmitter<boolean>();
    @Output() onDataRegister = new EventEmitter<any>();

    showModalOrders: boolean = false;
    tipoDeGuardado: string;
    placeholderfiscalCode: string;
    placeholderCustomerName: string;
    placeholdercustomerSurnameFirst: string;
    placeholdercustomerBussinesName: string;
    placeholderfiscalCodeFrance: string;
    dfichero: string;
    file: string;
    formularioGuardado: any;
    formMode: boolean = false;
    selectedVehicle: Vehicle = undefined;
    autorization: string;
    contador: string;
    cont: number;
    dataCustomer: any;
    TelephonePortable: string;
    telefonofijo: string;
    private _modoEdicion: boolean;
    set modoEdicion(enabled) {
        this._modoEdicion = this.isModal ? false : enabled;
    }
    get modoEdicion() {
        return this._modoEdicion;
    }
    email: string;
    emailPara: string;
    documentos: Documentos[];
    courtesies: Courtesies[];
    fechaActual: any;
    newCustomer: boolean;
    dataCustomerSave: any;
    textoBox: string;
    pais: string;
    voClientes: boolean;
    gestionTerceros: boolean;
    Taller_recepcionVehiculos: boolean;
    facturacionManual: boolean;
    facturacionRecibida: boolean;
    entradasAlmacen: boolean;
    dossierVenta: boolean;
    _Almacen: boolean;
    pedidosPiezas: boolean;
    _Facturas: boolean;
    gestionArticulos: boolean;
    ventaVo: boolean;
    gestionOr: boolean;
    presupuestosTaller: boolean;
    CustomerCodePhone: string;
    tratamiento: Courtesies;
    formSubmitted = false;
    activarLamparita: boolean;
    isValidEntryFiscalCode = true;
    customerCode: string;
    dataCustomers: any[] = [];
    selectedAccount: any;
    totalElements: any[] = [];
    error: string;
    code: string;
    textObligado: string;
    cliente: boolean;
    empresa: boolean;
    public innerWidth: any;
    _small = false;
    messageResult: boolean;
    formularioNewCustomer: boolean;
    formularioOldCustomer: boolean;
    subjectCustomer: Subscription; //recoge el row
    isMoveOn: Subscription; // manejador
    isMoveIn: Subscription; // manejador
    isCreadoCustomer: Subscription;  // se creo el formulario
    isLight: Subscription; // bombilla
    errorFiscalObligatorio: boolean;
    errorFiscalFormato: boolean;
    errorFiscalDuplicado: boolean;
    isLoadingTerceros: boolean = false;
    matriculaOk: boolean;
    VinOk: boolean;
    matriculaDuplicate: boolean;
    VinDuplicate: boolean;
    tipo: string;
    PlateNumber: string;
    Vin: string;
    chassis: string;
    customerId: string;
    culture: any;
    showModalPhone: boolean = false;
    showModalMail: boolean = false;
    showModalDesactivar: boolean = false;
    showModalDelete: boolean = false;
    showModalDownloadExcel: boolean = false;
    showModalGeneric: boolean = false;
    fiscalCodeOrigen: string;
    generic_title: string;
    generic_textButtonOk: string;
    generic_textButtonCancel: string;
    generic_aspa: boolean;
    generic_popupName: string = '';
    generic_message: string;
    generic_isButtonOk: boolean;
    generic_isButtonCancel: boolean;
    conManejadores: boolean;
    sinManejadores: boolean;
    col12: boolean;
    col11: boolean;
    resetear: boolean;
    /******PESTAÑAS*******/
    showDatosIdentificacion: boolean;
    showDatosContacto: boolean;
    showContactos: boolean;
    showGestion: boolean;
    showVehiculos: boolean;
    showComunicaciones: boolean;
    showCentros: boolean;
    categories: Categories[];
    isRsdAdmin: boolean;
    menuChilds: any;
    emailMessageData: EmailMessageData;
    customerORList: any[];
    updateDetails: boolean = true; // Indica si se ha cambiado el IVA para recalcular facturas

    constructor(
        private _recepcionVehiculoStepsService: RecepcionVehiculoStepsService,
        private _dataSaveService: DataSaveService,
        private translateService: TranslateService,
        private toastr: ToastrService,
        public _loadingService: LoadingService,
        private _authService: AuthService,
        private _canBeDeleteService: CanBeDeleteService,
        private _renderer: Renderer2,
        public _gestionTercerosService: GestionTercerosService,
        public _generalGestionTercerosService: GeneralGestionTercerosService,
        public _sharedPanelService: SharedPanelService,
        private _globals: GlobalsService,
        private _adjuntarDocumentosService: AdjuntarDocumentosService,
        private _customerValidationService: CustomerValidationService,
        private _ORCustomerVehicleService: ORCustomerVehicleService,
        private _buttonsActivateService: ButtonsActivateService
    ) {
        this.activarLamparita = false;
        this.fechaActual = this._globals.getDateFormatToday();
        this.placeholderfiscalCode = '';
        this.placeholderCustomerName = '';
        this.placeholdercustomerSurnameFirst = '';
        this.placeholdercustomerBussinesName = '';
        this.placeholderfiscalCodeFrance = '';
        this.modoEdicion = false;
        this.conManejadores = false;
        this.sinManejadores = false;
        this.col12 = false;
        this.col11 = false;
        this.resetear = false;
        this.menuChilds = ChildsMenuEnum;
    }

    ngOnDestroy(): void {
        this.subjectCustomer.unsubscribe();
    }
    ngOnInit() {
        this.textoBox = this.cargarVista === 'voClientes' ? 'genericos.informationBox.gestionterceros.text02vo' : 'genericos.informationBox.gestionterceros.text02';
        this.cargarCategorias();
        this.formMode = this._authService.getUserRole();
        this.isRsdAdmin = this._gestionTercerosService.rsdAdminRole();
        this.pais = this._authService.getDataPais();

        if (!this.tab) {
            this.tab = 0;
        }

        // cuando crea el formulario ya sea vacio o con datos pasa por aqui (a menos que este guardado)
        this.isCreadoCustomer = this._gestionTercerosService.observerCreadoCustomer().subscribe(val => {
            if (val === true) {
                this.isLoadingTerceros = false;
                // Recibe el ok cuando se ha creado el formulario ya sea nuevo o antiguo
                if (this._gestionTercerosService.newCustomer) {
                    this.formularioNewCustomer = true;
                    this.formularioOldCustomer = false;
                    this.marcarTratamiento(1);
                } else {
                    this.formularioNewCustomer = false;
                    this.formularioOldCustomer = true;
                }
                this.blurElementDatosPrincipales('CustomerName');
                this.blurElementDatosPrincipales('customerSurnameFirst');
                this.blurElementDatosPrincipales('fiscalCode');
                this.blurElementDatosPrincipales('customerBussinesName');
                if (this.pais === 'pt') {
                    this._gestionTercerosService.isValidEntryFiscalCode = false;
                    this.blurFiscalCode();
                }
            }
        });

        this._gestionTercerosService.setPantalla(this.cargarVista);

        this.comboDocumento();
        this.comboTratamiento();

        this.translateService.get('errors.required.campoObligatorio').subscribe(text => {
            this.textObligado = text;
        });

        this.innerWidth = window.innerWidth;
        if (this.innerWidth <= 795) {
            this._small = true;
        } else {
            this._small = false;
        }

        this.cargarVistas();

        // cuando seleccionamos un row de la tabla tenemos un id de customer para crear nuestro formulario con datos
        this.subjectCustomer = this._gestionTercerosService.observerActualCustomerCode().subscribe(val => {
            if (!this.formularioGuardado) {
                this.isLoadingTerceros = true;
                this.customerId = val;
                if (!this._gestionTercerosService.newCustomer) {
                    this.GetByCustomerCodeWithContacts();
                } else {
                    this.modoEdicion = true;
                    this._gestionTercerosService.setModoEdicion(this.modoEdicion);
                    this.searchCustomerCode();
                }
            }
        });


        this.isMoveOn = this._gestionTercerosService.observerMoveOn().subscribe(val => {
            if (val === true) {
                this.startMove();
            }
        });

        this.isMoveIn = this._gestionTercerosService.observerMoveIn().subscribe(val => {
            if (val === true) {
                this.startMoveIn();
            }
        });

        this.isLight = this._sharedPanelService.observerisSwitchedOn().subscribe(val => {
            this.activarLamparita = val;
        });

        this._adjuntarDocumentosService.getMediaFileList().subscribe(data => {
            this.dataCustomer.CustomerMediaFileList = data;
        });
    } // fin init

    cargarVistas() {
        switch (this.cargarVista) {
            case 'gestionTerceros':
                // PANTALLAS
                this.voClientes = false;
                this.gestionTerceros = true;
                this.Taller_recepcionVehiculos = false;
                this.facturacionManual = false;
                this.facturacionRecibida = false;
                this.entradasAlmacen = false;
                this.dossierVenta = false;
                this._Almacen = false;
                this.pedidosPiezas = false;
                this._Facturas = false;
                this.gestionArticulos = false;
                this.ventaVo = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                // COLUMNAS
                this.columnas();
                // PESTAÑAS
                this.pestanas();
                this.cargarDatos();
                break;
            case 'voClientes':
                // PANTALLAS
                this.voClientes = true;
                this.gestionTerceros = false;
                this.Taller_recepcionVehiculos = false;
                this.facturacionManual = false;
                this.facturacionRecibida = false;
                this.entradasAlmacen = false;
                this.dossierVenta = false;
                this._Almacen = false;
                this._Facturas = false;
                this.gestionArticulos = false;
                this.ventaVo = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                // COLUMNAS
                this.columnas();
                // PESTAÑAS
                this.pestanas();
                this.cargarDatos();
                break;
            case 'facturacionManual':
                // PANTALLAS
                this.voClientes = false;
                this.gestionTerceros = false;
                this.Taller_recepcionVehiculos = false;
                this.facturacionManual = true;
                this.facturacionRecibida = false;
                this.entradasAlmacen = false;
                this.dossierVenta = false;
                this._Almacen = false;
                this._Facturas = false;
                this.gestionArticulos = false;
                this.ventaVo = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                // COLUMNAS
                this.columnas();
                // PESTAÑAS
                this.pestanas();
                break;
            case 'facturacionRecibida':
                // PANTALLAS
                this.voClientes = false;
                this.gestionTerceros = false;
                this.Taller_recepcionVehiculos = false;
                this.facturacionManual = false;
                this.facturacionRecibida = true;
                this.entradasAlmacen = false;
                this.dossierVenta = false;
                this._Almacen = false;
                this._Facturas = false;
                this.gestionArticulos = false;
                this.ventaVo = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                // COLUMNAS
                this.columnas();
                // PESTAÑAS
                this.pestanas();
                break;
            case 'entradasAlmacen':
                // PANTALLAS
                this.voClientes = false;
                this.gestionTerceros = false;
                this.Taller_recepcionVehiculos = false;
                this.facturacionManual = false;
                this.facturacionRecibida = false;
                this.entradasAlmacen = true;
                this.dossierVenta = false;
                this._Almacen = false;
                this._Facturas = false;
                this.gestionArticulos = false;
                this.ventaVo = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                // COLUMNAS
                this.columnas();
                // PESTAÑAS
                this.pestanas();
                break;
            case 'dossierVenta':
                // PANTALLAS
                this.voClientes = false;
                this.gestionTerceros = false;
                this.Taller_recepcionVehiculos = false;
                this.facturacionManual = false;
                this.facturacionRecibida = false;
                this.entradasAlmacen = false;
                this.dossierVenta = true;
                this._Almacen = false;
                this._Facturas = false;
                this.gestionArticulos = false;
                this.ventaVo = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                // COLUMNAS
                this.columnas();
                // PESTAÑAS
                this.pestanas();
                break;
            case 'Taller_recepcionVehiculos':
                // PANTALLAS
                this.voClientes = false;
                this.gestionTerceros = false;
                this.Taller_recepcionVehiculos = true;
                this.facturacionManual = false;
                this.facturacionRecibida = false;
                this.entradasAlmacen = false;
                this.dossierVenta = false;
                this._Almacen = false;
                this._Facturas = false;
                this.gestionArticulos = false;
                this.ventaVo = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                // COLUMNAS
                this.columnas();
                // PESTAÑAS
                this.pestanas();
                break;
            case 'Almacen':
                // PANTALLAS
                this.voClientes = false;
                this.gestionTerceros = false;
                this.Taller_recepcionVehiculos = false;
                this.facturacionManual = false;
                this.facturacionRecibida = false;
                this.entradasAlmacen = false;
                this.dossierVenta = false;
                this._Almacen = true;
                this._Facturas = false;
                this.gestionArticulos = false;
                this.ventaVo = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                // COLUMNAS
                this.columnas();
                // PESTAÑAS
                this.pestanas();
                break;
            case 'Facturas':
                this.voClientes = false;
                this.gestionTerceros = false;
                this.Taller_recepcionVehiculos = false;
                this.facturacionManual = false;
                this.facturacionRecibida = false;
                this.entradasAlmacen = false;
                this.dossierVenta = false;
                this._Almacen = false;
                this._Facturas = true;
                this.gestionArticulos = false;
                this.ventaVo = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                // COLUMNAS
                this.columnas();
                // PESTAÑAS
                this.pestanas();
                break;
            case 'gestionArticulos':
                this.voClientes = false;
                this.gestionTerceros = false;
                this.Taller_recepcionVehiculos = false;
                this.facturacionManual = false;
                this.facturacionRecibida = false;
                this.entradasAlmacen = false;
                this.dossierVenta = false;
                this._Almacen = false;
                this._Facturas = false;
                this.gestionArticulos = true;
                this.ventaVo = false;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                // COLUMNAS
                this.columnas();
                // PESTAÑAS
                this.pestanas();
                break;
            case 'ventaVo':
                this.voClientes = false;
                this.gestionTerceros = false;
                this.Taller_recepcionVehiculos = false;
                this.facturacionManual = false;
                this.facturacionRecibida = false;
                this.entradasAlmacen = false;
                this.dossierVenta = false;
                this._Almacen = false;
                this._Facturas = false;
                this.gestionArticulos = false;
                this.ventaVo = true;
                this.gestionOr = false;
                this.presupuestosTaller = false;
                // COLUMNAS
                this.columnas();
                // PESTAÑAS
                this.pestanas();
                break;
            case 'gestionOr':
                this.voClientes = false;
                this.gestionTerceros = false;
                this.Taller_recepcionVehiculos = false;
                this.facturacionManual = false;
                this.facturacionRecibida = false;
                this.entradasAlmacen = false;
                this.dossierVenta = false;
                this._Almacen = false;
                this._Facturas = false;
                this.gestionArticulos = false;
                this.ventaVo = false;
                this.gestionOr = true;
                this.presupuestosTaller = false;

                // COLUMNAS
                this.columnas();
                // PESTAÑAS
                this.pestanas();
                break;
            case 'presupuestosTaller':
                this.voClientes = false;
                this.gestionTerceros = false;
                this.Taller_recepcionVehiculos = false;
                this.facturacionManual = false;
                this.facturacionRecibida = false;
                this.entradasAlmacen = false;
                this.dossierVenta = false;
                this._Almacen = false;
                this._Facturas = false;
                this.gestionArticulos = false;
                this.ventaVo = false;
                this.gestionOr = false;
                this.presupuestosTaller = true;
                // COLUMNAS
                this.columnas();
                // PESTAÑAS
                this.pestanas();
                break;

        }
    }

    pestanas() {
        switch (this.cargarVista) {
            case 'gestionTerceros':
                if (this._gestionTercerosService.newCustomer) {
                    this.showDatosIdentificacion = true;
                    this.showDatosContacto = true;
                    this.showContactos = false;
                    this.showGestion = true;
                    this.showVehiculos = false;
                    this.showComunicaciones = false;
                    this.showCentros = this._authService.getDataPais() === 'es';
                } else {
                    this.showDatosIdentificacion = true;
                    this.showDatosContacto = true;
                    this.showContactos = true;
                    this.showGestion = true;
                    this.showVehiculos = true;
                    this.showComunicaciones = true;
                    this.showCentros = this._authService.getDataPais() === 'es';
                }
                break;
            case 'voClientes':
                if (this._gestionTercerosService.newCustomer) {
                    this.showDatosIdentificacion = true;
                    this.showDatosContacto = true;
                    this.showContactos = false;
                    this.showGestion = false;
                    this.showVehiculos = false;
                    this.showComunicaciones = false;
                    this.showCentros = this._authService.getDataPais() !== 'fr';
                } else {
                    this.showDatosIdentificacion = true;
                    this.showDatosContacto = true;
                    this.showContactos = false;
                    this.showGestion = false;
                    this.showVehiculos = true;
                    this.showComunicaciones = true;
                    this.showCentros = this._authService.getDataPais() !== 'fr';
                }
                break;
            case 'Almacen':
            case 'Taller_recepcionVehiculos':
            case 'Facturas':
            case 'gestionArticulos':
            case 'ventaVo':
            case 'presupuestosTaller':
            case 'facturacionManual':
            case 'facturacionRecibida':
            case 'entradasAlmacen':
            case 'dossierVenta':
                this.showDatosIdentificacion = true;
                this.showDatosContacto = true;
                this.showContactos = false;
                this.showGestion = true;
                this.showVehiculos = false;
                this.showComunicaciones = false;
                this.showCentros = true;
                break;
            case 'gestionOr':
                this.showDatosIdentificacion = true;
                this.showDatosContacto = true;
                this.showContactos = true;
                this.showGestion = true;
                this.showVehiculos = true;
                this.showComunicaciones = true;
                this.showCentros = true;
                break;
        }
    }

    columnas() {
        switch (this.cargarVista) {
            case 'gestionTerceros':
                if (this._gestionTercerosService.newCustomer) {
                    this.sinManejadores = true;
                    this.col12 = true;
                    this.resetear = true;
                    this.conManejadores = false;
                    this.col11 = false;
                } else {
                    this.sinManejadores = false;
                    this.col12 = false;
                    this.resetear = false;
                    this.conManejadores = true;
                    this.col11 = true;
                }
                break;
            case 'Almacen':
            case 'Taller_recepcionVehiculos':
            case 'Facturas':
            case 'gestionArticulos':
            case 'ventaVo':
            case 'presupuestosTaller':
            case 'facturacionManual':
            case 'facturacionRecibida':
            case 'entradasAlmacen':
            case 'dossierVenta':
                this.sinManejadores = true;
                this.col12 = true;
                this.resetear = false;
                this.conManejadores = false;
                this.col11 = false;
                break;
            case 'voClientes':
                this.sinManejadores = true;
                this.col12 = true;
                this.resetear = true;
                this.conManejadores = false;
                this.col11 = false;
                break;
            case 'gestionOr':
                this.sinManejadores = false;
                this.col12 = false;
                this.conManejadores = true;
                this.col11 = true;
                break;
        }
    }

    cargarDatos() {
        // de momento solo para terceros , es el autoguardado
        this.formularioGuardado = this._dataSaveService.getFormulario(this.cargarVista) ? this._dataSaveService.getFormulario(this.cargarVista).form : null;
        if (this.formularioGuardado) {
            this.dataCustomer = this._gestionTercerosService.getByCustomerCodeWithContactsSave();
            this.marcarTratamiento(this.formularioGuardado.datosPrincipales.tratamiento);
            if (this.dataCustomer) {
                this._gestionTercerosService.crearFormularioCustomerCargado(this.cargarVista, this.formularioGuardado);
            }
        }
    }

    closeModalOrder(result) {
        if (result.guardado === 'guardar') {
            this.continuarModificarCustomer(true);
        }else if (result.guardado === 'cerrar') {
            this.continuarModificarCustomer();
        }
        this.showModalOrders = false;
    }

    search(event) {
        const query = event.query;
        const parametros = {
            searchValue: event.query,
            orderBy: null,
            State: 2,
            pageInfo: {
                Number: 1,
                Size: 30
            }
        };

        const _URL_ = `${environment.ENTORNO}${environment.SessionService.URL_General}FindPaged`;
        this._generalGestionTercerosService.findAlphabeticalPaged(_URL_, parametros).subscribe(data => {
            const auxData = data.Response.Content;
            if (auxData) {
                this.dataCustomers = this.filterCustomers(query, auxData);
            }
        });
    }

    filterCustomers(query, customers: any[]): any[] {
        const filtered: any[] = [];
        for (let i = 0; i < customers.length; i++) {
            const customer = customers[i];
            if (customer.CustomerName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                filtered.push(customer);
            }
        }
        return filtered;
    }

    setSelectedName(event) {
        // al seleccionar te rellena la pantalla y ya no es uno nuevo
        this.selectedAccount = event;
        if (this.cargarVista === 'Taller_recepcionVehiculos' ||
            this.cargarVista === 'facturacionManual' ||
            this.cargarVista === 'facturacionRecibida' ||
            this.cargarVista === 'entradasAlmacen' ||
            this.cargarVista === 'dossierVenta' ||
            this.cargarVista === 'gestionArticulos') {
            this.onDataRegister.emit(this.selectedAccount);
        }

        this._gestionTercerosService.customerForm.get('datosPrincipales').get('CustomerCode').setValue(event.CustomerCode, { eventEmit: false });
        this._gestionTercerosService.newCustomer = false;
        this.customerId = this.selectedAccount.CustomerId;
        this._gestionTercerosService.setCustomer(this.selectedAccount.CustomerId);
        this._adjuntarDocumentosService.setCustomer(this.selectedAccount.CustomerId);
    }

    searchCustomerCode() {
        this._gestionTercerosService.getUniqueSearchCode().subscribe((resp) => {
            this.customerCode = resp.Response.Data;

            if (this.cargarVista === 'voClientes') {
                this._gestionTercerosService.crearFormularioCustomer(this.cargarVista, this.customerCode, '2');
            } else {
                this._gestionTercerosService.crearFormularioCustomer(this.cargarVista, this.customerCode, '0');
            }
        });
    }

    renovarCustomerCode() {
        this._gestionTercerosService.getUniqueSearchCode().subscribe((resp) => {
            this.customerCode = resp.Response.Data;
            this._gestionTercerosService.customerForm.get('datosPrincipales').get('CustomerCode').setValue(this.customerCode, { eventEmit: false });
        });
    }

    comboDocumento() {

        const _URL_ = `${environment.ENTORNO}${environment.SessionService.URL_Identification}${environment.SessionService.ENDPOINT.GetAll}`;
        const parametros = '';
        this._generalGestionTercerosService.getCustomerIdentification(_URL_, parametros).subscribe(data => {
            const auxdata = data.contents;
            if (auxdata) {
                this.documentos = auxdata;
            }
        });
    }

    comboTratamiento() {
        const _URL_ = `${environment.ENTORNO}${environment.SessionService.URL_General}${environment.SessionService.ENDPOINT.GetCustomerCourtesies}`;
        const parametros = '';
        this._generalGestionTercerosService.getCourtesies(_URL_, parametros).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.courtesies = auxdata;
            }
        });
    }

    public valueChange(value: any): void { }

    GetByCustomerCodeWithContacts() {
        const _URL_ = `${environment.ENTORNO}Services/General/CustomerService.svc/GetByCustomerCodeWithContacts`;

        const Parametros_IN = {
            searchValue: this.customerId
        };
        this._generalGestionTercerosService.getByCustomerCodeWithContacts(_URL_, Parametros_IN).subscribe(data => {
            const auxData = data.Response;
            if (auxData) {
                auxData.FiscalCode = auxData.FiscalCode ? auxData.FiscalCode : '';
                this.dataCustomer = auxData;
                this._buttonsActivateService.actualizarBtnAdjuntoHasItems(auxData.CustomerMediaFileList.length > 0);
                this._customerValidationService.canUpdateCustomerAddress(auxData.CustomerId).subscribe(result => {
                    this._gestionTercerosService.canUpdateAddress = result;
                    this._gestionTercerosService.setByCustomerCodeWithContactsSave(this.dataCustomer);
                    this.gestionarDatosCustomerCodeWithContacts(this.dataCustomer);
                });
            }
        });
    }

    cargarCategorias() {
        const parametros = '';
        const _URL_ = `${environment.ENTORNO}${environment.SessionService.URL_CustomerCategory}${environment.SessionService.ENDPOINT.GetAll}`;
        this._generalGestionTercerosService.getCustomerCategories(_URL_, parametros).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.categories = auxdata;
                this._gestionTercerosService.categories = this.categories;
            }
        });
    }

    gestionarDatosCustomerCodeWithContacts(dataCustomer) {
        this.comprobarModoEdicion(dataCustomer.Courtesy);
        this._gestionTercerosService.setAllDataCustomer(dataCustomer);

        this._gestionTercerosService.crearFormularioCustomerWithData(this.cargarVista, dataCustomer, this.categories);

        this.CustomerCodePhone = dataCustomer.CustomerId;
        this.TelephonePortable = dataCustomer.TelephonePortable;
        this.telefonofijo = dataCustomer.TelephoneHome;
        this.emailPara = dataCustomer.Email;
        this.marcarTratamiento(dataCustomer.Courtesy);

        if (dataCustomer.Privacy === 'N') {
            this.generic_popupName = 'autorizacion',
                this.generic_aspa = false;
            this.generic_isButtonOk = true;
            this.generic_isButtonCancel = false;
            this.generic_title = 'labels.alert';
            this.generic_message = 'genericos.toastr.warningPricacity';
            this.generic_textButtonOk = 'labels.aceptar';
            this.generic_textButtonCancel = 'cancel';
            this.showModalGeneric = true;
        }
        this.getEmailMessageData();
    }
    getEmailMessageData(){
        this.emailMessageData = {
            emailTo: this.emailPara
        }
    }
    marcarTratamiento(tratamento) {
        if (tratamento === 0) {
            this.tratamiento = tratamento + 1;
        } else {
            this.tratamiento = tratamento;
        }
        this.cliente = false;
        this.empresa = false;
        switch (this.pais) {
            case 'es':
                //VAlidacion de customerSurnameFirst si tratamiento no es 4
                if (tratamento === 4) {
                    this.setValidatorRequired('customerSurnameFirst', null);
                    this.setValidatorRequired('fiscalCode', Validators.required);
                    this.setValidatorRequired('fiscalCode', Validators.required);
                    this.cliente = false;
                    this.empresa = true;

                } else {
                    this.setValidatorRequired('customerSurnameFirst', Validators.required);
                    this.setValidatorRequired('fiscalCode', Validators.required);

                    this.cliente = true;
                    this.empresa = false;
                }
                break;
            case 'pt':
                //VAlidacion de customerSurnameFirst si tratamiento no es 4
                if (tratamento === 4) {
                    this.setValidatorRequired('customerSurnameFirst', null);
                    this.setValidatorRequired('fiscalCode', Validators.required);
                    this.cliente = false;
                    this.empresa = true;

                } else {
                    this.setValidatorRequired('customerSurnameFirst', Validators.required);
                    this.setValidatorRequired('fiscalCode', null);

                    this.cliente = true;
                    this.empresa = false;
                }
                break;
            case 'fr':
                if (tratamento === 5 || tratamento === 6 || tratamento === 15) {
                    this.setValidatorRequired('customerSurnameFirst', null);
                    this.setValidatorRequired('fiscalCode', Validators.required);
                    this.cliente = false;
                    this.empresa = true;
                } else {
                    this.setValidatorRequired('fiscalCode', null);
                    this.setValidatorRequired('customerSurnameFirst', Validators.required);
                    this.cliente = true;
                    this.empresa = false;
                }
                break;

        }

    }

    comprobarModoEdicion(courtesy) {
        this.modoEdicion = false;
        //Si es empresa o tenemos permiso de edicion
        if (courtesy === 4 || courtesy === 5 || courtesy === 6 || courtesy === 15 || this.isGDPRAuthorized) {
            this.modoEdicion = true;
        } else {
            this.modoEdicion = false;
        }
        this._gestionTercerosService.setModoEdicion(this.modoEdicion);
    }

    setValidatorRequired(campo, requerido) {
        this._gestionTercerosService.customerForm.controls.datosPrincipales.get(campo).setValidators(requerido);
        this._gestionTercerosService.customerForm.controls.datosPrincipales.get(campo).updateValueAndValidity();
    }

    newTratamiento(value: any): void {
        this.tratamiento = value;
        this.marcarTratamiento(this.tratamiento);
        this.placeholderfiscalCode = '';
        this.placeholderfiscalCodeFrance = '';
        if(this.empresa){
            this._gestionTercerosService.customerForm.controls.datosPrincipales.get('customerSurnameFirst').setValue(null);
            this._gestionTercerosService.customerForm.controls.datosPrincipales.get('customerSurnameSecond').setValue(null);
        }
    }

    stopDerecha() {
        this._gestionTercerosService.setMoveDer(false);
    }

    irDerecha() {
        this._gestionTercerosService.setMoveDer(true);
    }

    startMove() {
        let conti = this.tabstripCarrousel.nativeElement.children[0].children[0].style.marginLeft;

        if (conti === '') {
            conti = 0;
        } else {
            const arrayConti: any = conti.split('px');
            conti = parseInt(arrayConti[0], 10);
        }
        for (let cont = conti; cont <= 200; cont++) {
            setTimeout(() => {
                const contador = cont + 'px';
                this._renderer.setStyle(this.tabstripCarrousel.nativeElement.children[0].children[0], 'marginLeft', contador);
            }, 500);
        }
    }

    startMoveIn() {
        let conti = this.tabstripCarrousel.nativeElement.children[0].children[0].style.marginLeft;
        if (conti === '') {
            conti = 0;
        } else {
            const arrayConti: any = conti.split('px');
            conti = parseInt(arrayConti[0], 10);
        }
        for (let cont2 = conti; cont2 >= -300; cont2--) {
            setTimeout(() => {

                const contador2 = cont2 + 'px';
                this._renderer.setStyle(this.tabstripCarrousel.nativeElement.children[0].children[0], 'marginLeft', contador2);
            }, 500);
        }
    }

    derecha() {
        let conti = this.tabstripCarrousel.nativeElement.children[0].children[0].style.marginLeft;
        if (conti === '' || conti === '0px') {
            conti = 0;
        } else {
            const arrayConti: any = conti.split('px');
            conti = parseInt(arrayConti[0], 10);
            const auxCont = conti + 100;
            const newCont = auxCont + 'px';
            this._renderer.setStyle(this.tabstripCarrousel.nativeElement.children[0].children[0], 'marginLeft', newCont);
        }
    }

    izquierda() {
        let conti = this.tabstripCarrousel.nativeElement.children[0].children[0].style.marginLeft;

        if (conti !== '-200px') {
            if (conti === '') {
                conti = 0;
            } else {
                const arrayConti: any = conti.split('px');
                conti = parseInt(arrayConti[0], 10);
            }
            const auxCont = conti - 100;
            const newCont = auxCont + 'px';

            this._renderer.setStyle(this.tabstripCarrousel.nativeElement.children[0].children[0], 'marginLeft', newCont);
        }
    }

    irIzquierda() {
        this._gestionTercerosService.setMoveIzq(true);
    }

    onTabSelect(e) {
        const auxTab = {
            'tab': e.index
        };
        this._dataSaveService.setTabsView(this.cargarVista, auxTab);
    }

    hasError(name) {
        return this._gestionTercerosService.customerForm.get('datosPrincipales').get(name).hasError('required') && this._gestionTercerosService.customerForm.get('datosPrincipales').get(name).touched;
    }

    idTypeChange(event: any) {
        this._gestionTercerosService.customerForm.get('datosPrincipales').get('fiscalCode').markAsTouched();
        if (event == '02') {
            this.blurElementDatosPrincipales('fiscalCode');
            this.blurFiscalCode();
            if (this.pais === 'fr') {
                this.blurElementFiscalCodeFrance();
            }
        }
    }

    blurElementDatosPrincipales(name) {
        if (this._gestionTercerosService.customerForm.get('datosPrincipales').get(name).hasError('required') &&
            (this._gestionTercerosService.customerForm.get('datosPrincipales').get(name).value === ''
                || this._gestionTercerosService.customerForm.get('datosPrincipales').get(name).value === null)
        ) {
            switch (name) {
                case 'fiscalCode':
                    switch (this.pais) {
                        case 'es':
                            if (this.empresa) {
                                this.placeholderfiscalCode = this.textObligado;
                            } else {
                                this.placeholderfiscalCode = this.textObligado;
                            }
                            break;
                        case 'pt':
                            if (this.empresa) {
                                this.placeholderfiscalCode = this.textObligado;
                            } else {
                                this.placeholderfiscalCode = '';
                            }
                            break;
                        case 'fr':
                            this.placeholderfiscalCode = '';
                            break;
                    }

                    break;
                case 'CustomerName':
                    this.placeholderCustomerName = this.textObligado;
                    break;
                case 'customerSurnameFirst':
                    this.placeholdercustomerSurnameFirst = this.textObligado;
                    break;
                case 'customerBussinesName':
                    this.placeholdercustomerBussinesName = this.textObligado;
            }
        } else {
            this.placeholderfiscalCode = '';
            this.placeholderCustomerName = '';
            this.placeholdercustomerSurnameFirst = '';
            this.placeholdercustomerBussinesName = '';
        }
    }

    blurElementFiscalCodeFrance() {
        if (this.empresa) {
            if (this._gestionTercerosService.customerForm.get('datosPrincipales').get('fiscalCode').hasError('required') &&
                (this._gestionTercerosService.customerForm.get('datosPrincipales').get('fiscalCode').value === ''
                    || this._gestionTercerosService.customerForm.get('datosPrincipales').get('fiscalCode').value === null)
            ) {
                this.placeholderfiscalCodeFrance = this.textObligado;
            }
        } else {
            this.placeholderfiscalCodeFrance = '';
        }
    }

    comprobarErroresFrance() {
        return this._gestionTercerosService.customerForm.get('datosPrincipales').get('fiscalCode').hasError('required') &&
            (this._gestionTercerosService.customerForm.get('datosPrincipales').get('fiscalCode').value === ''
                || this._gestionTercerosService.customerForm.get('datosPrincipales').get('fiscalCode').value === null);
    }

    siVacio(name) {
        return this._gestionTercerosService.customerForm.get('datosPrincipales').get(name).hasError('required') &&
            (this._gestionTercerosService.customerForm.get('datosPrincipales').get(name).value === ''
                || this._gestionTercerosService.customerForm.get('datosPrincipales').get(name).value === null);
    }

    getValueControl(name) {
        return this._gestionTercerosService.customerForm.get('datosPrincipales').get(name).value === '' || this._gestionTercerosService.customerForm.get('datosPrincipales').get(name).value === null;
    }

    comprobarFiscalErrores() {
        this.errorFiscalObligatorio = false;
        this.errorFiscalFormato = false;
        this.errorFiscalDuplicado = false;
        const paisSelector = this._gestionTercerosService.customerForm.get('datosIdentificacion').get('pais').value.CountryCode;

        if(this.pais === 'pt' && paisSelector !== 'PT'){
            this.errorFiscalObligatorio = false;
            this.errorFiscalFormato = false;
            this.errorFiscalDuplicado = false;
        }else{
            if (
                this._gestionTercerosService.customerForm.get('datosPrincipales').get('fiscalCode').hasError('required') &&
                (this._gestionTercerosService.customerForm.get('datosPrincipales').get('fiscalCode').value === ''
                    || this._gestionTercerosService.customerForm.get('datosPrincipales').get('fiscalCode').value === null)
            ) {
                switch (this.pais) {
                    case 'es':
                        if (this.empresa) {
                            this.errorFiscalObligatorio = true;
                        } else {
                            this.errorFiscalObligatorio = true;
                        }
                        break;
                    case 'pt':
                        if (this.empresa) {
                            this.errorFiscalObligatorio = true;
                        } else {
                            this.errorFiscalObligatorio = false;
                        }
                        break;
                }
            }
            // solo se comprueba si esta bien escrito si es DNI IdentificationType === '02'
            const auxIdentificationType = this._gestionTercerosService.customerForm.get('datosPrincipales').get('IdentificationType').value;

            if (auxIdentificationType === '02' && !this._gestionTercerosService.isValidEntryFiscalCode &&
                this._gestionTercerosService.customerForm.get('datosPrincipales').get('fiscalCode').value !== '' &&
                this._gestionTercerosService.customerForm.get('datosPrincipales').get('fiscalCode').touched) {
                this.errorFiscalFormato = true;
            }

            if (this._gestionTercerosService.isDuplicateFiscalCode &&
                this._gestionTercerosService.customerForm.get('datosPrincipales').get('fiscalCode').value !== '' &&
                this._gestionTercerosService.customerForm.get('datosPrincipales').get('fiscalCode').touched) {
                this.errorFiscalDuplicado = true;
            }
        }

        if (this.errorFiscalObligatorio) {
            return 1;
        } else if (this.errorFiscalFormato) {
            return 2;
        } else if (this.errorFiscalDuplicado) {
            return 3;
        } else {
            return 0;
        }
    }

    deleteCustomer() {
        const Parametros_IN = {
            customerID: this.customerId
        };

        this._canBeDeleteService.post<any>(JSON.stringify(Parametros_IN)).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {

                this._gestionTercerosService.puedeBorrarse = auxdata.Data;

                if (this._gestionTercerosService.puedeBorrarse) {
                    this.showModalDelete = true;
                }
            }
        });
    }

    reactivar() {
        const parametros_In = {
            customerID: this.dataCustomer.CustomerId
        };

        this._gestionTercerosService.customerReactivated(JSON.stringify(parametros_In)).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                if (auxdata.Data) {
                    this.translateService.get('genericos.toastr.successfulReactivate').subscribe(text => {
                        this.toastr.success(text);
                    });
                } else {
                    this.translateService.get('genericos.toastr.errorReactivar').subscribe(res => {
                        this.toastr.error(res);
                    });
                }
            } else {
                this.error = data.Warning.Content;
                this.code = data.Warning.Title;
                this.translateService.get('genericos.toastr.imposibleborrar').subscribe(res => {
                    this.toastr.error(res);
                });

            }
            this._gestionTercerosService.anterior(this.cargarVista);
        });

    }

    desactivarCustomer() {
        const parametros_In = {
            thirdParty: this.dataCustomer
        };
        this.dataCustomer.VOExpedientList = null;
        this.dataCustomer.CustomerContactChannelTypeList = null;
        this.dataCustomer.CustomerContactPurposeTypeList = null;
        this.dataCustomer.ClientCustomerRegistry = null;
        this.dataCustomer.CLIPE = null;

        this._gestionTercerosService.customerCanBeDeactivated(JSON.stringify(parametros_In)).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                if (auxdata.Data) {
                    if (this._gestionTercerosService.sePuedeDesactivar) {
                        this.showModalDesactivar = true;
                    }
                } else {
                    this.generic_popupName = 'dardebaja';
                    this.generic_aspa = false;
                    this.generic_isButtonOk = true;
                    this.generic_isButtonCancel = false;
                    this.generic_title = 'titulos.GEN_TERCEROS';
                    this.generic_message = 'gestion_terceros.popup.nobaja';
                    this.generic_textButtonOk = 'labels.aceptar';
                    this.generic_textButtonCancel = 'labels.cancelar';
                    this.showModalGeneric = true;
                }

            } else {
                this.error = data.Warning.Content;
                this.code = data.Warning.Title;
                this.translateService.get('genericos.toastr.imposibleborrar').subscribe(res => {
                    this.toastr.error(res);
                });
            }
        });
    }

    anadirDatosExterno() {
        if (this._gestionTercerosService.newCustomer) {
            this.anadirDatos();
        } else {
            this.guardarDatos();
        }
    }

    guardarDatos() {
        if (this._gestionTercerosService.customerForm.valid) {
            const datosForm = this._gestionTercerosService.customerForm.getRawValue();
            this.tipoDeGuardado = 'modificarCustomer';
            this.updateDetails = (this.dataCustomer.ClientCustomerRegistry && this.dataCustomer.ClientCustomerRegistry.ExemptionVatCode) != datosForm.gestion.ExemptionVatCode;
            if (this._gestionTercerosService.isValidEntryFiscalCode) {
                this.modificarCustomer();
            } else if (this.pais == 'pt' && datosForm.datosPrincipales.fiscalCode == '') {
                this.modificarCustomer();
            } else {
                this.popupDniInvalido('modificarCustomer');
            }
        }
    }

    anadirDatos() {
        const datosFormulario = this._gestionTercerosService.customerForm.getRawValue();
        const paisSelector = this._gestionTercerosService.customerForm.get('datosIdentificacion').get('pais').value.CountryCode;

        this.tipoDeGuardado = 'guardarNewCustomer';
        if (this._gestionTercerosService.isValidEntryFiscalCode) {
            this.guardarNewCustomer();
        } else if (this.pais == 'pt' && (datosFormulario.datosPrincipales.fiscalCode == '' || paisSelector !== 'PT')) {
            this.guardarNewCustomer();
        } else {
            this.popupDniInvalido('guardarNewCustomer');
        }

    }

    modificarCustomer() {
        if (this.cargarVista === 'gestionTerceros') {
            const customerCode = this._gestionTercerosService.actualCustomerCode.getValue();
            this._ORCustomerVehicleService.getCustomerOR(customerCode).subscribe(customerData =>{
                this.customerORList = customerData.customerORList;
                if (customerData.customerWithOR) {
                    this.showModalOrders = true;
                } else {
                    this.continuarModificarCustomer();
                }
            });
        } else {
            this.continuarModificarCustomer();
        }
    }

    continuarModificarCustomer(ORCustomerModification = false) {
        const datosFormulario = this._gestionTercerosService.customerForm.getRawValue();
        this._recepcionVehiculoStepsService.setCurrentCustomer(datosFormulario.datosPrincipales.CustomerCode);
        let parametros_In: any = {};
        let ClientCustomerRegistry = new ClientCustomerRegistryModel();
        const SupplierCustomerRegistry = new SupplierCustomerRegistryModel();

        const auxCustomerType = datosFormulario.datosIdentificacion.customerType;
        SupplierCustomerRegistry.ArcadCode = datosFormulario.datosIdentificacion.arcadCode ? datosFormulario.datosIdentificacion.arcadCode : '';
        SupplierCustomerRegistry.Bis770 = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.Bis770 : null;
        SupplierCustomerRegistry.BrandCode = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.BrandCode : null;
        SupplierCustomerRegistry.CLIENTCODE = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.CLIENTCODE : this.dataCustomer.ClientCode;
        SupplierCustomerRegistry.COMPANYCODE = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.COMPANYCODE : this.dataCustomer.CompanyCode;
        SupplierCustomerRegistry.CUSTOMERCODE = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.CUSTOMERCODE : this.dataCustomer.CustomerId;
        SupplierCustomerRegistry.Causal770 = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.Causal770 : null;
        SupplierCustomerRegistry.CausalCode = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.CausalCode : null;
        SupplierCustomerRegistry.CommonCustomerRegistry = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.CommonCustomerRegistry : null;
        SupplierCustomerRegistry.LastPurchaseDate = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.LastPurchaseDate : null;
        SupplierCustomerRegistry.NationCode = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.NationCode : null;
        SupplierCustomerRegistry.PhysicalPerson = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.PhysicalPerson : false;
        SupplierCustomerRegistry.RevocaDate = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.RevocaDate : null;

        if (this.dataCustomer.ClientCustomerRegistry) {
            ClientCustomerRegistry.AbiCode = this.dataCustomer.ClientCustomerRegistry.AbiCode ? this.dataCustomer.ClientCustomerRegistry.AbiCode : null,
                ClientCustomerRegistry.CLIENTCODE = this.dataCustomer.ClientCustomerRegistry.CLIENTCODE ? this.dataCustomer.ClientCustomerRegistry.CLIENTCODE : null,
                ClientCustomerRegistry.COMPANYCODE = this.dataCustomer.ClientCustomerRegistry.COMPANYCODE ? this.dataCustomer.ClientCustomerRegistry.COMPANYCODE : null,
                ClientCustomerRegistry.CUSTOMERCATEGORY = datosFormulario.datosIdentificacion.customerCategory.CUSTOMERCATEGORY;
            ClientCustomerRegistry.CUSTOMERCODE = this.dataCustomer.ClientCustomerRegistry.CUSTOMERCODE ? this.dataCustomer.ClientCustomerRegistry.CUSTOMERCODE : null,
                ClientCustomerRegistry.CabCode = this.dataCustomer.ClientCustomerRegistry.CabCode ? this.dataCustomer.ClientCustomerRegistry.CabCode : null,
                ClientCustomerRegistry.ClientType = this.dataCustomer.ClientCustomerRegistry.ClientType ? this.dataCustomer.ClientCustomerRegistry.ClientType : null,
                ClientCustomerRegistry.CountryCode = this.dataCustomer.ClientCustomerRegistry.CountryCode ? this.dataCustomer.ClientCustomerRegistry.CountryCode : null,
                ClientCustomerRegistry.DeductionAccountPct = this.dataCustomer.ClientCustomerRegistry.DeductionAccountPct ? this.dataCustomer.ClientCustomerRegistry.DeductionAccountPct : 0,
                ClientCustomerRegistry.ExemptionVatCode = datosFormulario.gestion.ExemptionVatCode;
            ClientCustomerRegistry.ExpensesPayment = this.dataCustomer.ClientCustomerRegistry.ExpensesPayment ? this.dataCustomer.ClientCustomerRegistry.ExpensesPayment : false,
                ClientCustomerRegistry.FLDOPVInterface = this.dataCustomer.ClientCustomerRegistry.FLDOPVInterface ? this.dataCustomer.ClientCustomerRegistry.FLDOPVInterface : false,
                ClientCustomerRegistry.IncomePct = this.dataCustomer.ClientCustomerRegistry.IncomePct ? this.dataCustomer.ClientCustomerRegistry.IncomePct : 0,
                ClientCustomerRegistry.LastSaleDate = this.dataCustomer.ClientCustomerRegistry.LastSaleDate ? this.dataCustomer.ClientCustomerRegistry.LastSaleDate : null,
                ClientCustomerRegistry.NCCLIENTCODE = this.dataCustomer.ClientCustomerRegistry.NCCLIENTCODE ? this.dataCustomer.ClientCustomerRegistry.NCCLIENTCODE : '*',
                ClientCustomerRegistry.RevocaDate = this.dataCustomer.ClientCustomerRegistry.RevocaDate ? this.dataCustomer.ClientCustomerRegistry.RevocaDate : null,
                ClientCustomerRegistry.STATISTICSALESCODE = this.dataCustomer.ClientCustomerRegistry.STATISTICSALESCODE ? this.dataCustomer.ClientCustomerRegistry.STATISTICSALESCODE : '**',
                ClientCustomerRegistry.StampPayment = this.dataCustomer.ClientCustomerRegistry.StampPayment ? this.dataCustomer.ClientCustomerRegistry.StampPayment : false,
                ClientCustomerRegistry.WorkshopCode = this.dataCustomer.ClientCustomerRegistry.WorkshopCode ? this.dataCustomer.ClientCustomerRegistry.WorkshopCode : null;
        } else {
            if (auxCustomerType !== 'S') {
                ClientCustomerRegistry.CLIENTCODE = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.CLIENTCODE : this.dataCustomer.ClientCode;
                ClientCustomerRegistry.COMPANYCODE = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.COMPANYCODE : this.dataCustomer.CompanyCode;
                ClientCustomerRegistry.CUSTOMERCATEGORY = datosFormulario.datosIdentificacion.customerCategory.CUSTOMERCATEGORY;
                ClientCustomerRegistry.CUSTOMERCODE = this.dataCustomer.SupplierCustomerRegistry ? this.dataCustomer.SupplierCustomerRegistry.CUSTOMERCODE : this.dataCustomer.CustomerId;
                ClientCustomerRegistry.DeductionAccountPct = 0;
                ClientCustomerRegistry.ExemptionVatCode = datosFormulario.gestion.ExemptionVatCode;
                ClientCustomerRegistry.ExpensesPayment = false;
                ClientCustomerRegistry.FLDOPVInterface = false;
                ClientCustomerRegistry.IncomePct = 0;
                ClientCustomerRegistry.NCCLIENTCODE = '*';
                ClientCustomerRegistry.STATISTICSALESCODE = '**';
                ClientCustomerRegistry.StampPayment = false;
            } else {
                ClientCustomerRegistry = null;
            }
        }

        parametros_In = {
            thirdParty: {
                /**********  DATOS PRINCIPALES********/
                CustomerCode: datosFormulario.datosPrincipales.CustomerCode,
                IdentificationType: datosFormulario.datosPrincipales.IdentificationType,
                Name2: datosFormulario.datosPrincipales.CustomerName,
                FiscalCode: datosFormulario.datosPrincipales.fiscalCode,
                Courtesy: datosFormulario.datosPrincipales.tratamiento,
                LastName1: datosFormulario.datosPrincipales.customerSurnameFirst,// nuevo
                LastName2: datosFormulario.datosPrincipales.customerSurnameSecond,// nuevo
                SelfEmployed: datosFormulario.datosPrincipales.customerSelfEmployed, //Autonomo
                BussinesName: datosFormulario.datosPrincipales.customerBussinesName, //Razon social
                /**********  DATOS IDENTIFICACION********/
                InternalAditionalRole: Number(datosFormulario.datosIdentificacion.InternalAditionalRole),
                CustomerType: datosFormulario.datosIdentificacion.customerType,
                Address: datosFormulario.datosIdentificacion.address,
                Notes: datosFormulario.datosIdentificacion.notas,
                City: datosFormulario.datosIdentificacion.city,
                Country: datosFormulario.datosIdentificacion.pais,
                PostalCode: datosFormulario.datosIdentificacion.postalCode,
                Province: datosFormulario.datosIdentificacion.province,
                NationalityCode: datosFormulario.datosIdentificacion.NationalityCode,
                IntraCommunity: datosFormulario.datosIdentificacion.IntraCommunity,
                BornDate: datosFormulario.datosIdentificacion.fechaNacimiento ? this._globals.getDateFormatForServer(datosFormulario.datosIdentificacion.fechaNacimiento) : null,
                SupplierCustomerRegistry: SupplierCustomerRegistry,
                /**********  DATOS CONTACTO********/
                TelephoneHome: datosFormulario.contactInformation.telephoneHome,
                TelephoneOffice: datosFormulario.contactInformation.telephoneOffice,
                TelephonePortable: datosFormulario.contactInformation.telephonePortable,
                Email: datosFormulario.contactInformation.email,
                Fax: datosFormulario.contactInformation.fax,
                Privacy: datosFormulario.contactInformation.privacy, // El CLiente autoriza SI NO el tratamiento de sus datos
                CustomerContactChannelTypeList: datosFormulario.contactInformation.customerContactChannelTypeList,
                CustomerContactPurposeTypeList: datosFormulario.contactInformation.customerContactPurposeTypeList,
                DateSignatureConsentDocument: datosFormulario.contactInformation.dateSignatureConsentDocument ? this._globals.getDateFormatForServerNoTime(datosFormulario.contactInformation.dateSignatureConsentDocument) : null,// Fecha de firma
                ThirdAssignment: datosFormulario.contactInformation.thirdAssignment, // Permitir C.Comerciales de la Marca
                AllowContactBrand: datosFormulario.contactInformation.allowContactBrand, // Permite cesion de terceros
                AllowProfilingBrand: datosFormulario.contactInformation.allowProfilingBrand, // Permite perfilado marca
                ConsentDocumentId: datosFormulario.contactInformation.consentDocumentId,
                /**********  CONTACTOS ********/
                ClientContacts: datosFormulario.contacts.clientContacts,
                /**********  GESTION ********/
                ClientCustomerRegistry: ClientCustomerRegistry,
                CustomerDiscountPR: datosFormulario.gestion.DiscountPR,
                PriceMO: datosFormulario.gestion.PriceMO,
                DiscountMO: datosFormulario.gestion.DiscountMO,
                DiscountPR: datosFormulario.gestion.DiscountPR.DiscountCode,
                PaymentCode: datosFormulario.gestion.PaymentCode,
                SpecialDiscount: datosFormulario.gestion.SpecialDiscount,
                AccountingCode: datosFormulario.gestion.AccountingCode,
                MandateSigningDate: datosFormulario.gestion.MandateSigningDate ? this._globals.getDateFormatForServer(datosFormulario.gestion.MandateSigningDate) : null,
                MandateReference: datosFormulario.gestion.MandateReference,
                CreditLimit: datosFormulario.gestion.CreditLimit,
                CreditLocked: datosFormulario.gestion.CreditLocked,
                CreditSpent: datosFormulario.gestion.CreditSpent,
                PaymentDay1: datosFormulario.gestion.PaymentDay1 ? datosFormulario.gestion.PaymentDay1 : 0,
                PaymentDay2: datosFormulario.gestion.PaymentDay2 ? datosFormulario.gestion.PaymentDay2 : 0,
                AmountPendingCashPayments: datosFormulario.gestion.AmountPendingCashPayments,
                Iban: datosFormulario.gestion.Iban,

                /**********  OTROS ********/
                ClientCode: this.dataCustomer.ClientCode,
                Company: this.dataCustomer.Company,
                CompanyCode: this.dataCustomer.CompanyCode,
                CreationDate: this.dataCustomer.CreationDate ? this._globals.getDateFormatForServer(this.dataCustomer.CreationDate) : null,
                CustomerId: this.dataCustomer.CustomerId,
                CustomerName: this.dataCustomer.CustomerName,
                AllowedCommercialActionsByBrand: this.dataCustomer.AllowedCommercialActionsByBrand,
                AllowedCommercialActionsByGarage: this.dataCustomer.AllowedCommercialActionsByGarage,
                CLIPE: this.dataCustomer.CLIPE,
                CustomerAutoSMSType: this.dataCustomer.CustomerAutoSMSType,
                CustomerMediaFileList: this.dataCustomer.CustomerMediaFileList,
                MaxLimitCashPayments: this.dataCustomer.MaxLimitCashPayments,
                Status: this.dataCustomer.Status,
                AdminCenterEReceptorId: datosFormulario.centres ? datosFormulario.centres.AdminCenterEReceptorId : this.dataCustomer.AdminCenterEReceptorId,
                AdminCenterEPayerId: datosFormulario.centres ? datosFormulario.centres.AdminCenterEPayerId : this.dataCustomer.AdminCenterEPayerId,
                AdminCenterEBuyerId: datosFormulario.centres ? datosFormulario.centres.AdminCenterEBuyerId : this.dataCustomer.AdminCenterEBuyerId,
                AdminCenterEFiscalId: datosFormulario.centres ? datosFormulario.centres.AdminCenterEFiscalId : this.dataCustomer.AdminCenterEFiscalId,
                IsoCode: datosFormulario.datosIdentificacion.pais.CountryCode,
                VATRegime: datosFormulario.datosIdentificacion.VATRegime
            }
        };
        parametros_In.thirdParty = parametros_In.thirdParty;
        this._loadingService.setLoading(true);
        this._gestionTercerosService.customerUpdate(JSON.stringify(parametros_In)).subscribe((resp) => {
            this._loadingService.setLoading(false);
            // this.customerCode = resp.CustomerCode; // Este servicio no esta devolviendo este valor, se comenta para evitar errores
            if(this.dataCustomer.ClientCustomerRegistry && datosFormulario.gestion.ExemptionVatCode){
                this.dataCustomer.ClientCustomerRegistry.ExemptionVatCode = datosFormulario.gestion.ExemptionVatCode;
            }
            if (this.cargarVista === 'Taller_recepcionVehiculos' ||
                this.cargarVista === 'facturacionManual' ||
                this.cargarVista === 'facturacionRecibida' ||
                this.cargarVista === 'entradasAlmacen' ||
                this.cargarVista === 'dossierVenta'
            ) {
                this.generic_popupName = 'desdeRecepcionVehiculos';
                this.generic_aspa = false;
                this.generic_isButtonOk = true;
                this.generic_isButtonCancel = false;
                this.generic_title = 'labels.aviso';
                this.generic_message = 'gestion_terceros.popup.cambiarDatos';
                this.generic_textButtonOk = 'labels.aceptar';
                this.generic_textButtonCancel = 'labels.cancelar';
                this.showModalGeneric = true;
            }
            if(ORCustomerModification){
                this.requestORCustomerMod(parametros_In);
            }
            this.translateService.get('genericos.toastr.successfulSave').subscribe(text => {
                this.toastr.success(text);
            });
        });
    }

    requestORCustomerMod(customerParams){
        const url = `${environment.ENTORNO}Services/General/CustomerService.svc/UpdateCustomerDataInDocumentsByCustomerCode`;
        const data = {
            item: customerParams.thirdParty
        }

        if (data.item.Courtesy === 4) {
            data.item.CustomerName = data.item.Name2;
        } else {
            data.item.CustomerName = `${data.item.LastName1} ${data.item.LastName2}, ${data.item.Name2}`;
        }

        this._loadingService.setLoading(true);
        this._generalGestionTercerosService.updateAllCustomersOR(url, {customerCode: data.item.CustomerId, updateDetails: this.updateDetails}).subscribe(data=> {
            this._loadingService.setLoading(false);
        });
    }

    guardarNewCustomer() {
        const datosFormulario = this._gestionTercerosService.customerForm.getRawValue();
        this._recepcionVehiculoStepsService.setCurrentCustomer(datosFormulario.datosPrincipales.CustomerCode);

        let ClientCustomerRegistry = new ClientCustomerRegistryModel();
        let SupplierCustomerRegistry = new SupplierCustomerRegistryModel();

        let auxCustomerType = '';
        if (this.cargarVista === 'voClientes') {
            auxCustomerType = 'C';
        } else {
            auxCustomerType = datosFormulario.datosIdentificacion.customerType;
        }

        let parametros_In: any = {};

        if (auxCustomerType !== 'S') {
            ClientCustomerRegistry.AbiCode = null;
            ClientCustomerRegistry.CLIENTCODE = null;
            ClientCustomerRegistry.COMPANYCODE = null;
            ClientCustomerRegistry.CUSTOMERCATEGORY = datosFormulario.datosIdentificacion.customerCategory.CUSTOMERCATEGORY;
            ClientCustomerRegistry.CUSTOMERCODE = null;
            ClientCustomerRegistry.CabCode = null;
            ClientCustomerRegistry.ClientType = null;
            ClientCustomerRegistry.CountryCode = null;
            ClientCustomerRegistry.DeductionAccountPct = 0;
            ClientCustomerRegistry.ExemptionVatCode = datosFormulario.gestion.ExemptionVatCode;
            ClientCustomerRegistry.ExpensesPayment = false;
            ClientCustomerRegistry.FLDOPVInterface = false;
            ClientCustomerRegistry.IncomePct = 0;
            ClientCustomerRegistry.LastSaleDate = null;
            ClientCustomerRegistry.NCCLIENTCODE = '*';
            ClientCustomerRegistry.RevocaDate = null;
            ClientCustomerRegistry.STATISTICSALESCODE = '**';
            ClientCustomerRegistry.StampPayment = false;
            ClientCustomerRegistry.WorkshopCode = null;
        } else {
            ClientCustomerRegistry = null;
        }

        if (datosFormulario.datosIdentificacion.arcadCode || datosFormulario.datosIdentificacion.customerType !== 'C') {
            SupplierCustomerRegistry.ArcadCode = datosFormulario.datosIdentificacion.arcadCode;
            SupplierCustomerRegistry.Bis770 = null;
            SupplierCustomerRegistry.BrandCode = null;
            SupplierCustomerRegistry.CLIENTCODE = null;
            SupplierCustomerRegistry.COMPANYCODE = null;
            SupplierCustomerRegistry.CUSTOMERCODE = null;
            SupplierCustomerRegistry.Causal770 = null;
            SupplierCustomerRegistry.CausalCode = null;
            SupplierCustomerRegistry.CommonCustomerRegistry = null;
            SupplierCustomerRegistry.LastPurchaseDate = null;
            SupplierCustomerRegistry.NationCode = null;
            SupplierCustomerRegistry.PhysicalPerson = false;
            SupplierCustomerRegistry.RevocaDate = null;
        } else {
            SupplierCustomerRegistry = null;
        }
        if (this.cargarVista === 'voClientes') {
            parametros_In = {
                item:
                {
                    /**********  DATOS extras para CLIENTES VO ********/
                    Corrency: null,
                    CustomerCourtesy: datosFormulario.datosPrincipales.tratamiento,
                    CustomerMediaFileList: [],
                    GenerateReceipt: false,
                    IsCompany: false,
                    LastNames: datosFormulario.datosPrincipales.customerSurnameFirst + datosFormulario.datosPrincipales.customerSurnameSecond,
                    ShowNetAndDiscount: true,
                    VATRegime: null,
                    VOExpedientList: [],
                    Vehicle: null,
                    isSignedConsentDocument: false,
                    sfVehicleId: null,

                    /**********  DATOS PRINCIPALES********/
                    CustomerCode: datosFormulario.datosPrincipales.CustomerCode,
                    IdentificationType: datosFormulario.datosPrincipales.IdentificationType,
                    Name2: datosFormulario.datosPrincipales.CustomerName,
                    FiscalCode: datosFormulario.datosPrincipales.fiscalCode,
                    Courtesy: datosFormulario.datosPrincipales.tratamiento,
                    LastName1: datosFormulario.datosPrincipales.customerSurnameFirst, // nuevo
                    LastName2: datosFormulario.datosPrincipales.customerSurnameSecond, // nuevo
                    /**********  DATOS IDENTIFICACION********/
                    InternalAditionalRole: Number(datosFormulario.datosIdentificacion.InternalAditionalRole), // 0 |2 radio button origen:taller -vo
                    CustomerType: auxCustomerType,
                    Address: datosFormulario.datosIdentificacion.address,
                    Notes: datosFormulario.datosIdentificacion.notas,
                    City: datosFormulario.datosIdentificacion.city,
                    Country: datosFormulario.datosIdentificacion.pais,
                    PostalCode: datosFormulario.datosIdentificacion.postalCode,
                    Province: datosFormulario.datosIdentificacion.province,
                    NationalityCode: datosFormulario.datosIdentificacion.NationalityCode,
                    IntraCommunity: datosFormulario.datosIdentificacion.IntraCommunity,
                    BornDate: datosFormulario.datosIdentificacion.fechaNacimiento ? this._globals.getDateFormatForServer(datosFormulario.datosPrincipales.fechaNacimiento) : null,
                    SupplierCustomerRegistry: SupplierCustomerRegistry,
                    /**********  DATOS CONTACTO********/
                    TelephoneHome: datosFormulario.contactInformation.telephoneHome,
                    TelephoneOffice: datosFormulario.contactInformation.telephoneOffice,
                    TelephonePortable: datosFormulario.contactInformation.telephonePortable,
                    Email: datosFormulario.contactInformation.email,
                    Fax: datosFormulario.contactInformation.fax,
                    Privacy: datosFormulario.contactInformation.privacy, // El CLiente autoriza SI NO el tratamiento de sus datos
                    CustomerContactChannelTypeList: datosFormulario.contactInformation.customerContactChannelTypeList,
                    CustomerContactPurposeTypeList: datosFormulario.contactInformation.customerContactPurposeTypeList,
                    DateSignatureConsentDocument: datosFormulario.contactInformation.dateSignatureConsentDocument ? this._globals.getDateFormatForServerNoTime(datosFormulario.contactInformation.dateSignatureConsentDocument) : null,// Fecha de firma
                    ThirdAssignment: datosFormulario.contactInformation.thirdAssignment, // Permitir C.Comerciales de la Marca
                    AllowContactBrand: datosFormulario.contactInformation.allowContactBrand, // Permite cesion de terceros
                    AllowProfilingBrand: datosFormulario.contactInformation.allowProfilingBrand, // Permite perfilado marca
                    ConsentDocumentId: datosFormulario.contactInformation.consentDocumentId,
                    /**********  CONTACTOS ********/
                    ClientContacts: [], // No se envia si es Nuevo  CLIENTES_VO
                    /**********  GESTION ********/
                    ClientCustomerRegistry: ClientCustomerRegistry,
                    CustomerDiscountPR: datosFormulario.gestion.DiscountPR,
                    PriceMO: datosFormulario.gestion.PriceMO,
                    DiscountMO: datosFormulario.gestion.DiscountMO,
                    DiscountPR: datosFormulario.gestion.DiscountPR.DiscountCode,
                    PaymentCode: datosFormulario.gestion.PaymentCode,
                    SpecialDiscount: datosFormulario.gestion.SpecialDiscount,
                    AccountingCode: datosFormulario.gestion.AccountingCode,
                    CreditLimit: datosFormulario.gestion.CreditLimit,
                    CreditLocked: datosFormulario.gestion.CreditLocked,
                    CreditSpent: datosFormulario.gestion.CreditSpent,
                    AmountPendingCashPayments: datosFormulario.gestion.AmountPendingCashPayments,
                    Iban: datosFormulario.gestion.Iban,
                    /********* OTROS ??****** */
                    MaxLimitCashPayments: 0,
                    Status: 'AC',
                    AdminCenterEReceptorId: datosFormulario.centres.AdminCenterEReceptorId,
                    AdminCenterEPayerId: datosFormulario.centres.AdminCenterEPayerId,
                    AdminCenterEBuyerId: datosFormulario.centres.AdminCenterEBuyerId,
                    AdminCenterEFiscalId: datosFormulario.centres.AdminCenterEFiscalId,
                    IsoCode: datosFormulario.datosIdentificacion.pais.CountryCode,
                    ClientCode: null,
                    Company: 'D',
                    CompanyCode: null,
                    CreationDate: this._globals.getDateFormatForServer(this.fechaActual),
                    CustomerAutoSMSType: null,
                    CustomerId: null,
                    CustomerName: datosFormulario.CustomerName ? datosFormulario.CustomerName : ''
                }
            };
            parametros_In.item = parametros_In.item;
        } else {
            parametros_In = {
                thirdParty: {
                    /**********  DATOS PRINCIPALES********/
                    CustomerCode: datosFormulario.datosPrincipales.CustomerCode,
                    IdentificationType: datosFormulario.datosPrincipales.IdentificationType,
                    Name2: datosFormulario.datosPrincipales.CustomerName,
                    FiscalCode: datosFormulario.datosPrincipales.fiscalCode,
                    Courtesy: datosFormulario.datosPrincipales.tratamiento,
                    LastName1: datosFormulario.datosPrincipales.customerSurnameFirst,// nuevo
                    LastName2: datosFormulario.datosPrincipales.customerSurnameSecond,// nuevo
                    /**********  DATOS IDENTIFICACION********/
                    InternalAditionalRole: Number(datosFormulario.datosIdentificacion.InternalAditionalRole),// 0 |2 radio button origen:taller -vo
                    CustomerType: datosFormulario.datosIdentificacion.customerType,
                    Address: datosFormulario.datosIdentificacion.address,
                    Notes: datosFormulario.datosIdentificacion.notas,
                    City: datosFormulario.datosIdentificacion.city,
                    Country: datosFormulario.datosIdentificacion.pais,
                    PostalCode: datosFormulario.datosIdentificacion.postalCode,
                    Province: datosFormulario.datosIdentificacion.province,
                    NationalityCode: datosFormulario.datosIdentificacion.NationalityCode,
                    IntraCommunity: datosFormulario.datosIdentificacion.IntraCommunity,
                    BornDate: datosFormulario.datosIdentificacion.fechaNacimiento ? this._globals.getDateFormatForServer(datosFormulario.datosIdentificacion.fechaNacimiento) : null,
                    SupplierCustomerRegistry: SupplierCustomerRegistry,
                    /**********  DATOS CONTACTO********/
                    TelephoneHome: datosFormulario.contactInformation.telephoneHome,
                    TelephoneOffice: datosFormulario.contactInformation.telephoneOffice,
                    TelephonePortable: datosFormulario.contactInformation.telephonePortable,
                    Email: datosFormulario.contactInformation.email,
                    Fax: datosFormulario.contactInformation.fax,
                    Privacy: datosFormulario.contactInformation.privacy, // El CLiente autoriza SI NO el tratamiento de sus datos
                    CustomerContactChannelTypeList: datosFormulario.contactInformation.customerContactChannelTypeList,
                    CustomerContactPurposeTypeList: datosFormulario.contactInformation.customerContactPurposeTypeList,
                    DateSignatureConsentDocument: datosFormulario.contactInformation.dateSignatureConsentDocument ? this._globals.getDateFormatForServerNoTime(datosFormulario.contactInformation.dateSignatureConsentDocument) : null,// Fecha de firma
                    ThirdAssignment: datosFormulario.contactInformation.thirdAssignment, // Permitir C.Comerciales de la Marca
                    AllowContactBrand: datosFormulario.contactInformation.allowContactBrand, // Permite cesion de terceros
                    AllowProfilingBrand: datosFormulario.contactInformation.allowProfilingBrand, // Permite perfilado marca
                    ConsentDocumentId: datosFormulario.contactInformation.consentDocumentId,
                    /**********  CONTACTOS ********/
                    //  ClientContacts:                     datosFormulario.contacts.clientContacts, // No se envia si es Nuevo
                    /**********  GESTION ********/
                    ClientCustomerRegistry: ClientCustomerRegistry,
                    CustomerDiscountPR: datosFormulario.gestion.DiscountPR,
                    PriceMO: datosFormulario.gestion.PriceMO,
                    DiscountMO: datosFormulario.gestion.DiscountMO,
                    DiscountPR: datosFormulario.gestion.DiscountPR.DiscountCode,
                    PaymentCode: datosFormulario.gestion.PaymentCode,
                    SpecialDiscount: datosFormulario.gestion.SpecialDiscount,
                    AccountingCode: datosFormulario.gestion.AccountingCode,
                    MandateSigningDate: datosFormulario.gestion.MandateSigningDate ? this._globals.getDateFormatForServer(datosFormulario.gestion.MandateSigningDate) : null,
                    MandateReference: datosFormulario.gestion.MandateReference,
                    CreditLimit: datosFormulario.gestion.CreditLimit,
                    CreditLocked: datosFormulario.gestion.CreditLocked,
                    CreditSpent: datosFormulario.gestion.CreditSpent,
                    PaymentDay1: datosFormulario.gestion.PaymentDay1 ? datosFormulario.gestion.PaymentDay1 : 0,
                    PaymentDay2: datosFormulario.gestion.PaymentDay2 ? datosFormulario.gestion.PaymentDay2 : 0,
                    AmountPendingCashPayments: datosFormulario.gestion.AmountPendingCashPayments,
                    Iban: datosFormulario.gestion.Iban,
                    /********* OTROS ??****** */
                    MaxLimitCashPayments: 0,
                    Status: 'AC',
                    AllowedCommercialActionsByBrand: 62,
                    AllowedCommercialActionsByGarage: 62,
                    AdminCenterEReceptorId: datosFormulario.centres.AdminCenterEReceptorId,
                    AdminCenterEPayerId: datosFormulario.centres.AdminCenterEPayerId,
                    AdminCenterEBuyerId: datosFormulario.centres.AdminCenterEBuyerId,
                    AdminCenterEFiscalId: datosFormulario.centres.AdminCenterEFiscalId,
                    IsoCode: datosFormulario.datosIdentificacion.pais.CountryCode,
                    ClientCode: null,
                    Company: null,
                    CompanyCode: null,
                    CreationDate: this._globals.getDateFormatForServer(this.fechaActual),
                    CustomerAutoSMSType: 'D',
                    CustomerId: null,
                    CustomerName: datosFormulario.CustomerName ? datosFormulario.CustomerName : '',
                    VATRegime: datosFormulario.datosIdentificacion.VATRegime
                }
            };
            parametros_In.thirdParty = parametros_In.thirdParty;
        }

        // comprobar si el codigo del customer es valido
        const CustomerCode = datosFormulario.datosPrincipales.CustomerCode;
        const parametros = {
            searchCode: CustomerCode
        };

        this._gestionTercerosService.searchCodeUnique(JSON.stringify(parametros)).subscribe(resp => {
            const auxdata = resp.Response;
            let _URL_ = '';
            if (auxdata === null) {
                if (this.cargarVista === 'voClientes') {
                    _URL_ = `${environment.ENTORNO}Services/VO/VOCustomerService.svc/Add`;
                } else {
                    _URL_ = `${environment.ENTORNO}Services/General/CustomerService.svc/Add`;
                }

                // Failsafe para situacion que se crean aseguradoras sin AccountingCode
                if (parametros_In.thirdParty.AccountingCode === null && parametros_In.thirdParty.CustomerType === 'A') {
                    parametros_In.thirdParty.AccountingCode = '';
                }

                this._generalGestionTercerosService.customerServiceAdd(_URL_, parametros_In).subscribe(data => {
                    const auxData = data.Response;
                    this.customerCode = data.CustomerCode;
                    this.translateService.get('genericos.toastr.successfulSave').subscribe(text => {
                        this.toastr.success(text);
                        if (this.cargarVista === 'Taller_recepcionVehiculos' ||
                            this.cargarVista === 'facturacionManual' ||
                            this.cargarVista === 'facturacionRecibida' ||
                            this.cargarVista === 'entradasAlmacen' ||
                            this.cargarVista === 'dossierVenta') {
                            this.generic_popupName = 'desdeRecepcionVehiculos';
                            this.generic_aspa = false;
                            this.generic_isButtonOk = true;
                            this.generic_isButtonCancel = false;
                            this.generic_title = 'labels.aviso';
                            this.generic_message = 'gestion_terceros.popup.cambiarDatos';
                            this.generic_textButtonOk = 'labels.aceptar';
                            this.generic_textButtonCancel = 'labels.cancelar';
                            this.showModalGeneric = true;

                            this.onDataRegister.emit(auxData);
                        } else if (this.cargarVista === 'presupuestosTaller') {
                            this.onDataRegister.emit(auxData);
                        } else if (this.cargarVista === 'Almacen') {
                            this.generic_popupName = 'desdeAlmacen';
                            this.generic_aspa = false;
                            this.generic_isButtonOk = true;
                            this.generic_isButtonCancel = false;
                            this.generic_title = 'titulos.GEN_TERCEROS';
                            this.generic_message = 'gestion_terceros.popup.guardadoOK';
                            this.generic_textButtonOk = 'labels.aceptar';
                            this.generic_textButtonCancel = 'labels.cancelar';
                            this.showModalGeneric = true;

                            this.onDataRegister.emit(auxData);
                        } else if (this.gestionArticulos) {
                            this.onDataRegister.emit(auxData);
                        } else {
                            this._gestionTercerosService.reset(this.cargarVista);
                            this._gestionTercerosService.anterior(this.cargarVista);
                        }
                    });
                });

            } else {
                this.generic_popupName = 'codigoRepetido',
                    this.generic_aspa = false;
                this.generic_isButtonOk = true;
                this.generic_isButtonCancel = true;
                this.generic_title = 'almacen.popup.codigoExistente';
                this.generic_message = 'almacen.popup.questionRepeat';
                this.generic_textButtonOk = 'almacen.popup.automaticCode';
                this.generic_textButtonCancel = 'labels.cancelar';
                this.showModalGeneric = true;
            }
        });
    }

    private throwAlertError(text1, text2) {
        this.toastr.error(text1, text2, {
            closeButton: true
        });
    }

    popupDniInvalido(tipoDeGuardado) {
        this.culture = sessionStorage.getItem('culture');
        const datosFormulario = this._gestionTercerosService.customerForm.getRawValue();
        this.generic_popupName = 'DNI';
        this.generic_aspa = false;
        this.generic_isButtonOk = this.culture != '"pt"' || this.culture == '"pt"' && datosFormulario.datosIdentificacion.pais.CountryCode != 'PT' ? true : false;
        this.generic_isButtonCancel = true;
        this.generic_title = 'messages.dniInvalidoTitle';
        this.generic_message = this.culture != '"pt"' || this.culture == '"pt"' && datosFormulario.datosIdentificacion.pais.CountryCode != 'PT' ? 'messages.dniInvalidoText' : 'DNI inválido';
        this.generic_textButtonOk = 'labels.si';
        this.generic_textButtonCancel = 'labels.cancelar';
        this.showModalGeneric = true;
    }

    closeModalGeneric(event) {
        this.showModalGeneric = false;
        if (event.nombrePopup === 'DNI' && event.datosPopup === 'aceptar') {
            if (this.tipoDeGuardado === 'guardarNewCustomer') {
                this.guardarNewCustomer();
            } else if (this.tipoDeGuardado === 'modificarCustomer') {
                this.modificarCustomer();
            } else {

            }
        } else if (event.nombrePopup === 'desdeRecepcionVehiculos' && event.datosPopup === 'aceptar') {
            this._gestionTercerosService.setUpdate();
        } else if (event.nombrePopup === 'desdeAlmacen' && event.datosPopup === 'aceptar') {
        } else if (event.nombrePopup === 'datosInvalidos' && event.datosPopup === 'aceptar') {
        } else if (event.nombrePopup === 'codigoRepetido' && event.datosPopup === 'aceptar') {
            this.renovarCustomerCode();
        } else if (event.nombrePopup === 'dardebaja' && event.datosPopup === 'aceptar') { }
    }

    cancelarOut() {
        this.cancel.emit(true);
    }

    closeModalDesactivar(event) {
        this.showModalDesactivar = false;
        // si es true se  deja el boton desactivado no se puede desactivar porque ya lo esta
        if (event === true) {
            // se refresca la pantalla a la tabla
            this._dataSaveService.setFormulario('gestionTerceros', { 'form': null });
            this._gestionTercerosService.anterior(this.cargarVista);
        }
    }

    closeModalDelete(event) {
        this.showModalDelete = false;
        this._dataSaveService.setFormulario('gestionTerceros', { 'form': null });
        this._gestionTercerosService.anterior(this.cargarVista);
    }

    openModalPhone() {
        this.showModalPhone = true;
    }

    closeModalPhone(event) {
        this.showModalPhone = false;
    }

    openModalMail() {
        this.showModalMail = true;
    }

    closeModalMail(event) {
        this.showModalMail = false;
    }

    closeModalDownloadExcel(event) {
        this.showModalDownloadExcel = false;
    }

    downExcel(event) {
        const _URL_ = `${environment.ENTORNO}Services/General/CustomerService.svc/ExportGDPRLogActivityCSVFile`;
        const parametros = {
            customerCode: this.dataCustomer.CustomerId
        };

        this._generalGestionTercerosService.exportGDPRLogActivityCSVFileService(_URL_, parametros).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                if (auxdata.Data === '') {
                    this.generic_popupName = 'sinActividad';
                    this.generic_title = 'labels.alert';
                    this.generic_textButtonOk = 'labels.aceptar';
                    this.generic_textButtonCancel = 'no';
                    this.generic_aspa = false;
                    this.generic_message = 'labels.no_activity';
                    this.generic_isButtonOk = true;
                    this.generic_isButtonCancel = false;

                    this.showModalGeneric = true;
                } else {
                    const link = auxdata.Data;
                    const dataToArray = link.split('/');
                    const arc = dataToArray[4].split('?');
                    this.file = arc[0];
                    this.dfichero = `${environment.ENTORNO}${dataToArray[3]}/${dataToArray[4]}`;
                    this.showModalDownloadExcel = true;
                }
            }
        });
    }

    canBeEdit() {
        if (this.formMode) {
            return true;
        } else {
            if (this._gestionTercerosService.newCustomer) {
                return false;
            } else {
                if (this.modoEdicion) {
                    return false;
                } else {
                    return true;
                }
            }
        }
    }

    blurFiscalCode(): void {
        const val = this._gestionTercerosService.customerForm.controls.datosPrincipales.get('fiscalCode').value;
        const identificationType = this._gestionTercerosService.customerForm.get('datosPrincipales').get('IdentificationType').value;
        this._gestionTercerosService.isValidEntryFiscalCode = false; // Invalidamos hasta que se valide
        if (val !== '') {
            const b = {
                fiscalCode: val
            };
            switch (this.pais) {
                case 'es':
                    if(identificationType === '02'){
                        this._gestionTercerosService.validacionFiscalCode(b);
                    }
                    break;
                case 'fr':
                    this._gestionTercerosService.validacionFiscalCode(b);
                    break;
                case 'pt':
                    this._gestionTercerosService.validacionFiscalCode(b);
                    break;
            }
        }
    }

    checkNifPt() {
        if (!this._gestionTercerosService.newCustomer && this._gestionTercerosService.isValidEntryFiscalCode === true) {
            return true;
        }
        return false;
    }

    undeleteCustomer(): void {
        const _URL_ = `${environment.ENTORNO}${environment.SessionService.URL_General}${environment.SessionService.ENDPOINT.Undelete}`;
        const parametros = {
            item: this.dataCustomer
        };
        this._generalGestionTercerosService.undeleteCustomer(_URL_, parametros).subscribe(
            data => {
                if (data.Response.Data) {
                    this.dataCustomer.Status = 'AC';
                    this._gestionTercerosService.setCustomer(this.dataCustomer.CustomerId);
                    this._adjuntarDocumentosService.setCustomer(this.dataCustomer.CustomerId);
                    this.translateService.get('genericos.toastr.successfulClientUndeleted').subscribe(text => {
                        this.toastr.success(text);
                    });
                }
            }
        );
    }
    changeAutonomo(){
        this._gestionTercerosService.customerForm.controls.datosPrincipales.get('customerBussinesName').updateValueAndValidity();
    }
}
